import { Component } from '@angular/core';
import { NavController, ToastController, LoadingController } from 'ionic-angular';
import { BarcodeScanner } from '@ionic-native/barcode-scanner';
import { Item  } from '@providers/asset/index';

import { DetailItemPage } from '../detail_item/page';
import { FormItemPage } from '../form_item/page';

@Component({
  selector: 'page-scan_code',
  templateUrl: 'page.html'
})
export class ScanCodePage {

  items : any = [];
  item_history : any = [];
  code  : any = {text:''};

  constructor(
    public itemApi        : Item,
    public navCtrl        : NavController,
    public barcodeScanner : BarcodeScanner,
    public toastCtrl      : ToastController,
    public loadingCtrl    : LoadingController
  ) {
    
  }
  
  ionViewDidEnter() {
    this.scan();
  }

  scan(){
    this.barcodeScanner.scan().then(barcodeData => {
      console.log('Barcode data', barcodeData);
      this.code = barcodeData;
      this.getItemByCode(this.code.text);
     }).catch(err => {
         console.log('Error', err);
     });
  }

  getItemByCode(code){
    if(code==''){
      return;
    }
    let loading = this.loadingCtrl.create({
      content: 'Please wait...'
    });
    loading.present();

    let params = {code: code};
    this.getItemHistory(params);
    this.itemApi.get(params).subscribe((resp:any) => {
      if(resp.data.length>0){
        this.items = resp.data;
      }else{
        this.toastCtrl.create({
          message : 'Item dengan code "'+code+'" tidak ditemukan',
          duration: 3000,
          position: 'top'
        }).present();
      }
      loading.dismiss();
    }, (err) => {
      loading.dismiss();
    });
  }
  getItemHistory(params){
    this.itemApi.getHistory(params).subscribe((resp:any) => {
      if(resp.data.length>0){
        this.item_history = resp.data;
      }
    });
  }

  select(id) {
    this.navCtrl.push(DetailItemPage, {
      id: id
    });
  }

  edit(id) {
    this.navCtrl.push(FormItemPage, {
      id: id
    });
  }
}



// WEBPACK FOOTER //
// ./src/pages/asset/scan_code/page.ts